export const downloadMediaFile = async (url: string, fileName: string): Promise<void> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Ошибка скачивания файла: ${response.status}`);
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(objectUrl);
};
